import * as React from 'react';

const EuiIconTokenField = ({ title, titleId, ...props }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M5.27 12V4h5.46v1.57H7.203v1.641h3.18v1.574h-3.18V12z"
    />
  </svg>
);

export const icon = EuiIconTokenField;
